import { SESSION_SPONSORS_FETCHED } from '../constants/ActionTypes';

export const getInitialState = () => ({
    'event-partners': {
        sponsors: [],
        exhibitors: []
    }
});

const SponsorsReducer = (state = getInitialState(), action = null) => {
    switch (action.type) {
    case SESSION_SPONSORS_FETCHED: {
        return {
            ...state,
            ...action.data
        };
    }
    default: {
        return state;
    }
    }
};

export default SponsorsReducer;
